module.exports = __webpack_public_path__ + "gl.svg?efc52e09e889e1c8589567db5d4d9934";